"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule = true;exports.default = void 0;

var _secToHms = require("./secToHms");






var _hmsToSec = _interopRequireDefault(require("./hmsToSec"));

var _convert = require("./convert");





var _tsTo = require("./tsTo");var _default =


{
  hmsToSec: _hmsToSec.default,

  secToHms: _secToHms.secToHms,
  secToHms_str: _secToHms.secToHms_str,
  secToHms_arr: _secToHms.secToHms_arr,
  secToHms_arrStr: _secToHms.secToHms_arrStr,

  fromObj: _convert.convertFromObj,
  fromWhatever: _convert.convert,
  toCurrentTimezone: _convert.toCurrentTimezone,

  tsToMs: _tsTo.tsToMs,
  tsToSec: _tsTo.tsToSec };exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/convert/index.js
// module id = 107
// module chunks = 0